export default __webpack_public_path__ + "static/media/icon-mastercard.f1d5ee59.svg";